import React from 'react';
const TermsPage = () => {
  return <div className="bg-white" data-id="element-1822" data-mp="2fby0fhn91w06">
      <div className="container mx-auto px-4 py-12" data-id="element-1823" data-mp="2592yvpn7p1qo">
        <h1 className="text-3xl md:text-4xl font-bold text-burgundy-600 mb-6" data-id="element-1824" data-mp="25acywkdmkjzy">
          Terms & Conditions
        </h1>
        <p className="mb-6" data-id="element-1825" data-mp="2k7naruu6jrw7">
          <span className="text-burgundy-600" data-id="element-1826" data-mp="2f792qcskwhy6">N</span>orthampton{' '}
          <span className="text-burgundy-600" data-id="element-1827" data-mp="2f5xzce31pc7l">D</span>riving{' '}
          <span className="text-burgundy-600" data-id="element-1828" data-mp="2t5yy9nzr29kf">S</span>chool – Learner Driver
          Terms & Conditions
        </p>
        <p className="mb-6" data-id="element-1829" data-mp="2o7e86he7p69p">
          By booking or attending lessons with Northampton Driving School, you
          agree to the following terms:
        </p>
        <section className="mb-8" data-id="element-1830" data-mp="2xx77aix63sx2">
          <h2 className="text-2xl font-bold text-burgundy-600 mb-4" data-id="element-1831" data-mp="2xz1vq77ne35w">
            1. Eligibility
          </h2>
          <ul className="list-disc pl-6 mb-4 space-y-2" data-id="element-1832" data-mp="3bxrqhg6zvqr3">
            <li data-id="element-1833" data-mp="37wpoirlp10lf">
              You must hold a valid UK provisional or full driving licence
              recognised in the UK.
            </li>
            <li data-id="element-1834" data-mp="2vp0ocwqvh3rt">
              You must show your licence to your instructor at your first lesson
              and whenever asked.
            </li>
            <li data-id="element-1835" data-mp="34ncnxo9pvbwe">
              Any penalty points, endorsements, or medical restrictions must be
              declared.
            </li>
          </ul>
        </section>
        <section className="mb-8" data-id="element-1836" data-mp="39kmcl1pa7jj6">
          <h2 className="text-2xl font-bold text-burgundy-600 mb-4" data-id="element-1837" data-mp="3emv742hsytne">
            2. Bookings & Payments
          </h2>
          <ul className="list-disc pl-6 mb-4 space-y-2" data-id="element-1838" data-mp="3imccyx155st3">
            <li data-id="element-1839" data-mp="3nendo23phimp">
              Lessons must be booked through the school or directly with your
              instructor.
            </li>
            <li data-id="element-1840" data-mp="3sc5cgzo0ehgz">
              Payment is required in advance to confirm bookings (individual
              lessons or block bookings).
            </li>
            <li data-id="element-1841" data-mp="669u8am1vgf0">
              Block booking discounts apply only when full payment is made in
              advance.
            </li>
          </ul>
        </section>
        <section className="mb-8" data-id="element-1842" data-mp="3cns6w66tsu0y">
          <h2 className="text-2xl font-bold text-burgundy-600 mb-4" data-id="element-1843" data-mp="37ofhpeshfav7">
            3. Attendance
          </h2>
          <ul className="list-disc pl-6 mb-4 space-y-2" data-id="element-1844" data-mp="3mdtuyxz6icfv">
            <li data-id="element-1845" data-mp="3memwnkja6br5">
              Your instructor will wait at the agreed pick-up point for up to 15
              minutes. If you do not attend, the lesson will be charged in full.
            </li>
            <li data-id="element-1846" data-mp="3vc5kewob746q">All pick-up and drop-off points must be pre-agreed.</li>
            <li data-id="element-1847" data-mp="3qdvpmn6hy5ln">
              If using your own car, it must be roadworthy, taxed, MOT'd, and
              insured for learner use. Proof of insurance must be shown each
              lesson.
            </li>
          </ul>
        </section>
        <section className="mb-8" data-id="element-1848" data-mp="45uofey5otm9">
          <h2 className="text-2xl font-bold text-burgundy-600 mb-4" data-id="element-1849" data-mp="2axn54r4rc0y6">
            4. Lesson Conduct
          </h2>
          <ul className="list-disc pl-6 mb-4 space-y-2" data-id="element-1850" data-mp="2603nricrj820">
            <li data-id="element-1851" data-mp="lh19sh5hvob3">
              Pupils must follow the instructor's instructions at all times.
            </li>
            <li data-id="element-1852" data-mp="qfuo2bslvjcb">
              Aggressive, unsafe, or abusive behaviour will result in immediate
              termination of lessons without refund.
            </li>
            <li data-id="element-1853" data-mp="bp3ylaehkwcd">
              Pupils must wear suitable footwear (no flip-flops, high heels, or
              unsafe shoes).
            </li>
          </ul>
        </section>
        <section className="mb-8" data-id="element-1854" data-mp="2pqivzzrrbj7">
          <h2 className="text-2xl font-bold text-burgundy-600 mb-4" data-id="element-1855" data-mp="2sw9xkryknhk">
            5. Fitness to Drive
          </h2>
          <ul className="list-disc pl-6 mb-4 space-y-2" data-id="element-1856" data-mp="3oxzxd1859uub">
            <li data-id="element-1857" data-mp="3ozksot2a9ht8">
              You must not be under the influence of alcohol, drugs, or
              medication that affects driving.
            </li>
            <li data-id="element-1858" data-mp="1n5vcg9p2bxt3">
              Lessons will be stopped if your instructor deems you unfit to
              drive, and the full lesson fee will still apply.
            </li>
          </ul>
        </section>
        <section className="mb-8" data-id="element-1859" data-mp="3o8urnk0ninjy">
          <h2 className="text-2xl font-bold text-burgundy-600 mb-4" data-id="element-1860" data-mp="3o82wubevotuq">
            6. Driving Tests
          </h2>
          <ul className="list-disc pl-6 mb-4 space-y-2" data-id="element-1861" data-mp="3j7f67qukaf11">
            <li data-id="element-1862" data-mp="3f6v9godwhdff">
              Instructors will only take pupils to a test if they are judged
              "test ready".
            </li>
            <li data-id="element-1863" data-mp="3aaxsqgyq6524">
              Use of the tuition car for a DVSA driving test is at the
              instructor's discretion.
            </li>
          </ul>
        </section>
        <section className="mb-8" data-id="element-1864" data-mp="30i8ljya7jdcl">
          <h2 className="text-2xl font-bold text-burgundy-600 mb-4" data-id="element-1865" data-mp="30h77rm1t4cr6">
            7. Liability
          </h2>
          <ul className="list-disc pl-6 mb-4 space-y-2" data-id="element-1866" data-mp="2ric2cc6l76ox">
            <li data-id="element-1867" data-mp="2rjwvbxd96hko">Our vehicles are insured and maintained to a safe standard.</li>
            <li data-id="element-1868" data-mp="2mi7hk9ynbpsw">
              Northampton Driving School is not liable for DVSA test
              cancellations, delays, fines, or penalties incurred by pupils.
            </li>
          </ul>
        </section>
        <section className="mb-8" data-id="element-1869" data-mp="x1c04nhglq5e">
          <h2 className="text-2xl font-bold text-burgundy-600 mb-4" data-id="element-1870" data-mp="x4ho1zecqlzj">
            8. Prices & Changes
          </h2>
          <ul className="list-disc pl-6 mb-4 space-y-2" data-id="element-1871" data-mp="170b7m2qhnfqt">
            <li data-id="element-1872" data-mp="170t6760mi61w">
              Prices may change at any time, but prior notice will be given
              where possible.
            </li>
          </ul>
        </section>
        <section className="mb-8" data-id="element-1873" data-mp="ecovg63732sc">
          <h2 className="text-2xl font-bold text-burgundy-600 mb-4" data-id="element-1874" data-mp="edgr1gwsl0im">
            9. Complaints
          </h2>
          <ul className="list-disc pl-6 mb-4 space-y-2" data-id="element-1875" data-mp="j8m924n2pv1f">
            <li data-id="element-1876" data-mp="nb96qm6fea6j">
              Please first raise any concerns directly with your instructor.
            </li>
            <li data-id="element-1877" data-mp="s3tx1dq4i55b">
              If unresolved, email info@northamptondrivingschool.co.uk. We aim
              to reply within 14 days.
            </li>
          </ul>
        </section>
        <section className="mb-8" data-id="element-1878" data-mp="3vr2di9ayg7ae">
          <h2 className="text-2xl font-bold text-burgundy-600 mb-4" data-id="element-1879" data-mp="3vq11a1i7der3">
            10. Governing Law
          </h2>
          <ul className="list-disc pl-6 mb-4 space-y-2" data-id="element-1880" data-mp="12van3fchl0qt">
            <li data-id="element-1881" data-mp="xxr9mhnm4rzx">These Terms are governed by the laws of England and Wales.</li>
          </ul>
        </section>
      </div>
    </div>;
};
export default TermsPage;